import { hasOwnProp } from '@/utils'
import { getCookie, setCookie, removeCookie } from 'tiny-cookie'
import { getSession, setSession, removeSession } from '@/service/sessionStorage.service'
import axios from '@/service/apiProvider.service'
import json from '@/service/jsonPrototype.service'
import config from '@/config'

/**
 * Verify auth-cookie
 * 
 * @param {string} prop
 */
function checkAuth (prop: string): any {
  const cookie: any = json.decrypt(getCookie(config.APP_AUTH))
  if (cookie && arguments.length && hasOwnProp(cookie, prop)) {
    return cookie[prop]
  } else {
    return false
  }
}

/**
 * State
 */
export const state: any = {
  auth  : Boolean(checkAuth('accessToken')),
  logged: checkAuth('logged'),
  user  : getSession(config.APP_USER)
    ? json.decrypt(getSession(config.APP_USER))
    : {}
}

/**
 * Getters
 */
export const getters: any = {
  auth (state: any): boolean {
    return Boolean(state.auth)
  },

  token (state: any): string {
    return state.auth
  },

  user (state: any): any {
    return state.user || {}
  }
}

/**
 * Mutations
 */
export const mutations: any = {
  AUTHEN (state: any, payload: any): void {
    const accessToken: string = `${payload.token_type} ${payload.access_token}`
    state.auth   = Boolean(payload.access_token)
    state.logged = payload.logged

    payload['accessToken'] = accessToken
    delete payload.password

    axios.defaults.headers.Authorization = accessToken as string
    setCookie(config.APP_AUTH, json.encrypt(payload), {
      expires: `${payload.expires_in}m`
    })
  },

  AUTH_USER (state: any, payload: boolean): void {
    state.user = payload
    setSession(config.APP_USER, json.encrypt(state.user))
  },

  DESTROY (state: any): void {
    state.auth    = false
    state.logged  = false
    state.user    = {}
    removeCookie(config.APP_AUTH)
    removeSession(config.APP_USER)
    delete axios.defaults.headers.Authorization
  }
}

/**
 * Actions
 */
export const actions: any = {
  /**
   * User login
   * @param {object} params
   */
  async login ({ commit, dispatch }: any, params: any) {
    let status: boolean = false

    try {
      const { data }: any = await axios.post('/auth/login', params)

      if (hasOwnProp(data, 'access_token')) {
        commit('AUTHEN', { ...params, ...data })
        await dispatch('User')
        status = true
      }
    } catch (err) {
      console.warn('WARNING:', err.message)
    }

    return Promise.resolve(status)
  },

  /**
   * Logout, Destroy all session.
   */
  async logout ({ commit }: any) {
    await axios.post('/auth/logout')
    commit('DESTROY')

    return Promise.resolve(true)
  },

  /**
   * Gathering user Profile-data.
   */
  async User ({ commit }: any) {
    let status: boolean = false

    try {
      const { data }: any = await axios.post('/auth/me')
      commit('AUTH_USER', data)
      status = true
    } catch (err) {
      console.warn('WARNING:', err.message)
    }

    return Promise.resolve(status)
  }
}